package org.matthewo.api

import kotlinx.serialization.Serializable

@Serializable
data class EventInfo(
    val name: String,
    val matches: Boolean,
    val rankings: Boolean,
    val playoffs: Boolean,
    val advancement: Boolean,
    val years: List<Int>,
    val divisions: List<Division>?,
) {
    @Serializable
    data class Division(
        val code: String,
        val name: String,
    )
}
